<template>
  <slot name="options" :selection="selection" />
  <slot />
</template>
<script
  setup
  lang="ts"
  generic="T extends Record<string, unknown> & { id: string }"
>
import { computed, provide } from 'vue';
import { BulkEdit, bulkEditInjectionKey } from './bulk-edit';
// items is only here for type inference.
// this is not the cleanest solution since you could technically lie to the compiler but i dont know a better solution either :(
defineProps<{ items?: T[] }>();

const bulkEdit = new BulkEdit<T>();

const selection = computed(() => {
  return Array.from(bulkEdit.selection.value);
});
provide(bulkEditInjectionKey, bulkEdit);
</script>
